/* eslint-disable prefer-destructuring */
import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';

import { ContentType } from '@/common/constants/ContentTypes';
import DiscussionStore from '@/stores/DiscussionStore';
import AuthStore from '@/stores/AuthStore';
import { Resource } from '@/types/Content/Resources';
import PostDisplay from '@/components/PostDisplay/PostDisplay';
import { Wrapper } from './styles';

type TldrProps = Pick<
  Resource,
  'tldr' | 'author' | 'createdAt' | 'body' | 'contentType' | 'updatedAt' | 'id'
>;

export function TLDRComponent({
  id,
  tldr,
  body,
  author,
  createdAt,
  updatedAt,
  contentType,
}: TldrProps): JSX.Element {
  const isDiscussion = useMemo(
    (): boolean => contentType === ContentType.DISCUSSIONS,
    [contentType],
  );

  const router = useRouter();

  const cmsUser = AuthStore.cmsUser;
  const isDeleted = DiscussionStore.isDeleted;
  const clear = DiscussionStore.clear;
  const requestDelete = DiscussionStore.requestDelete;
  const loadingDeletion = DiscussionStore.loadingDeletion;

  useEffect(() => {
    if (isDiscussion && isDeleted) {
      router.push('/discover');

      clear();
    }
  }, [isDeleted]);

  const isDeleteDiscussionEnabled = useMemo((): boolean => {
    if (!isDiscussion) return false;

    return cmsUser?.id === author?.id;
  }, [cmsUser, author, isDiscussion]);

  return (
    <Wrapper hasTldr={Boolean(tldr) || isDiscussion}>
      <PostDisplay
        chipProps={{
          label: 'Author',
          variant: 'highlighted',
        }}
        user={author}
        publication={{
          id,
          createdAt,
          updatedAt,
          body: tldr || body,
          deletable: isDeleteDiscussionEnabled,
          onDelete: requestDelete,
          loadingDeletion,
        }}
        commentProps={{ show: false }}
        id={id}
      />
    </Wrapper>
  );
}

export const TLDR = observer(TLDRComponent);

TLDRComponent.defaultProps = {
  tldr: null,
  body: null,
};
